// Normalize authentication context for all VinCentrix API requests.
// Fresh browsers may store dealership identity under a newer key than older sessions.
// This interceptor makes API requests consistent regardless of which supported key was written.
const originalFetch = window.fetch.bind(window);

const getStoredDealerId = () => {
  const keys = ['dealership', 'dealer', 'vincentrix_dealer'];

  for (const key of keys) {
    try {
      const raw = localStorage.getItem(key);
      if (!raw) continue;
      const parsed = JSON.parse(raw);
      if (parsed?.id) return parsed.id;
    } catch (error) {
      console.warn(`Unable to read ${key} from localStorage`, error);
    }
  }

  return null;
};

const getStoredToken = () => localStorage.getItem('token') || localStorage.getItem('vincentrix_token') || null;

const isVinCentrixApiRequest = (url) => {
  if (!url || !url.includes('/api/')) return false;

  try {
    const parsed = new URL(url, window.location.origin);
    const configuredApi = process.env.REACT_APP_API_URL;

    if (!configuredApi) return true;

    const apiOrigin = new URL(configuredApi, window.location.origin).origin;
    return parsed.origin === apiOrigin || parsed.origin === window.location.origin;
  } catch {
    return url.includes('/api/');
  }
};

const mergeHeaders = (existing, additions) => {
  const headers = new Headers(existing || {});

  Object.entries(additions).forEach(([key, value]) => {
    if (value) headers.set(key, value);
  });

  return headers;
};

const normalizeApiUrl = (url, dealerId) => {
  if (!url || !dealerId) return url;
  return String(url).replace('/api/integrations/test-dealer', `/api/integrations/${encodeURIComponent(dealerId)}`);
};

window.fetch = (input, init = {}) => {
  const originalUrl = typeof input === 'string' ? input : input?.url || '';

  if (!isVinCentrixApiRequest(originalUrl)) {
    return originalFetch(input, init);
  }

  const token = getStoredToken();
  const dealerId = getStoredDealerId();
  const headers = mergeHeaders(init.headers, {
    Authorization: token ? `Bearer ${token}` : null,
    'X-Dealership-Id': dealerId,
    'X-Dealer-Id': dealerId
  });
  const normalizedUrl = normalizeApiUrl(originalUrl, dealerId);
  const normalizedInput = typeof input === 'string' ? normalizedUrl : new Request(normalizedUrl, input);

  return originalFetch(normalizedInput, {
    ...init,
    headers
  });
};